import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const LEARNING_PAGE_SIDEBAR_FULL_WIDTH = 320;
const LEARNING_PAGE_SIDEBAR_REDUCED_WIDTH = 200;
const LearningPageSidebar = ({
  backgroundColor,
  children,
  id,
  withSubNav
}) => {
  const {
    isLaptop
  } = useMediaQuery();
  const sidebarWidth = isLaptop ? LEARNING_PAGE_SIDEBAR_REDUCED_WIDTH : LEARNING_PAGE_SIDEBAR_FULL_WIDTH;
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: backgroundColor,
    borderColor: "border-core-subtle",
    borderRadius: "300",
    borderStyle: "solid",
    borderWidth: "100",
    id: id,
    maxInlineSize: `${sidebarWidth}px`,
    minBlockSize: `calc(100vh - ${withSubNav ? '126px' : '86px'})`,
    minInlineSize: `${sidebarWidth}px`,
    overflow: "hidden",
    position: "relative",
    children: /*#__PURE__*/_jsx(View, {
      inset: "0",
      overflowY: "auto",
      position: "absolute",
      children: children
    })
  });
};
export default LearningPageSidebar;